exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h1[data-v-0bd2572a],h2[data-v-0bd2572a]{font-weight:400}ul[data-v-0bd2572a]{list-style-type:none;padding:0}li[data-v-0bd2572a]{display:inline-block;margin:0 10px}a[data-v-0bd2572a]{color:#42b983}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0bd2572a","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/MessageLogin.vue
// module id = ae1B
// module chunks = 0